import type { IconGlyph } from '../icon';

/**
 * Tractie `key-thick` glyph (medium, 24×24), shown on the current nav item.
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/key-thick.jsx`.
 * The circle is converted to an arc path, otherwise a verbatim copy of
 * the SVG `d` attribute, 2 paths in source order.
 */
export const iconKeyThick: IconGlyph = {
  name: 'key-thick',
  path: [
    'M18 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0',
    'M15.5 2A6.5 6.5 0 0 0 9 8.5c0 .47.05.92.14 1.36L2 17v5h5l1-1.07V19h1.81L11 17.73V16h1.62l1.15-1.23A6.5 6.5 0 1 0 15.49 2Zm0 11c-.79 0-1.53-.2-2.18-.56l-1.55 1.55h-1.76l-1 1v1.94l-.05.06H7.01l-1 1v2h-2v-2.17l7.42-7.42a4.5 4.5 0 0 1-.42-1.91c0-2.49 2.01-4.5 4.5-4.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5Z',
  ],
};
